import {useSyncExternalStore} from 'react'

/**
 * Subscribe function for useSyncExternalStore
 * Sets up event listeners for online/offline events
 */
const subscribe = (callback: () => void) => {
  const handleOnline = () => {
    console.log('🟢 Connection restored - You are now online')
    callback()
  }

  const handleOffline = () => {
    console.log('🔴 Connection lost - You are now offline')
    callback()
  }

  window.addEventListener('online', handleOnline)
  window.addEventListener('offline', handleOffline)

  return () => {
    window.removeEventListener('online', handleOnline)
    window.removeEventListener('offline', handleOffline)
  }
}

/**
 * Snapshot function for useSyncExternalStore
 * Returns the current online status
 */
const getSnapshot = () => navigator.onLine

/**
 * Custom hook to detect online/offline connectivity status using useSyncExternalStore
 * This is the modern React way to sync with external state (React 18+)
 *
 * @returns {boolean} isOnline - true if online, false if offline
 */
export const useOnlineStatus = (): boolean => {
  return useSyncExternalStore(subscribe, getSnapshot)
}
